import React, { useState } from "react";
import { Select, Button, LegacyStack, Banner } from "@shopify/polaris";
import { useTranslation } from "react-i18next";
import { useDispatch } from "react-redux";
import { setIsModalxOpen } from "../../../components/modalx/modalx.slice";
import { fetchOrders } from "../orders.slice";
import { AppDispatch } from "../../../configureStore";
import { requestRulesSignature } from "../../../services/orders.service";

interface SignatureModalProps {
  id_upload_transport?: number;
  type: string;
}

function SignatureModal({ id_upload_transport, type }: SignatureModalProps) {
  const { t } = useTranslation();
  const dispatch = useDispatch<AppDispatch>();
  const [language, setLanguage] = useState("LT");
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState<string | null>(null);
  const [success, setSuccess] = useState(false);

  const handleLanguageChange = (value: string) => {
    setLanguage(value);
  };

  const handleSubmit = async () => {
    setLoading(true);
    setError(null);
    setSuccess(false);

    // Determine which transport ID to use
    const transportId = id_upload_transport;

    if (!transportId) {
      setError("Transport ID is missing");
      setLoading(false);
      return;
    }

    try {
      const result = await requestRulesSignature(transportId, language, type);

      // Check for explicit success or if the API returned a valid response without an error
      if (result && (result.success === true || !result.error)) {
        setSuccess(true);
        // Close modal after 1 second
        setTimeout(() => {
          dispatch(setIsModalxOpen(false));
          dispatch(fetchOrders());
        }, 1000);
      } else {
        setError(result?.error || "Failed to send signature request");
      }
    } catch (err: any) {
      console.error("Error requesting signature:", err);
      setError(err.message || "Failed to send signature request");
    } finally {
      setLoading(false);
    }
  };

  const languageOptions = [
    { label: "Lietuvių", value: "LT" },
    { label: "English", value: "EN" },
    { label: "Русский", value: "RU" },
    { label: "Polski", value: "PL" },
  ];

  return (
    <LegacyStack vertical>
      {error && (
        <Banner tone="critical" onDismiss={() => setError(null)}>
          {error}
        </Banner>
      )}

      {success && (
        <Banner tone="success">
          {t("request_signature")} - {t("signed")}!
        </Banner>
      )}

      <Select
        label={t("select_language")}
        options={languageOptions}
        value={language}
        onChange={handleLanguageChange}
        disabled={loading || success}
      />

      <Button
        variant="primary"
        loading={loading}
        onClick={handleSubmit}
        disabled={success}
      >
        {t("request_signature")}
      </Button>
    </LegacyStack>
  );
}

export default SignatureModal;

